<template>
  <el-dialog
    :model-value="visible"
    destroy-on-close
    width="580px"
    :before-close="handleClose"
    :class="`password-update-dialog ${theme}`"
    :close-on-click-modal="false"
    title="修改密码"
  >
    <div class="bg"></div>
    <el-form ref="formRef" :model="formData" :rules="formRules" label-width="90px" class="form" label-position="left">
      <!-- <el-form-item label="原密码" prop="passWord">
        <el-input v-model="formData.passWord" autocomplete="off" placeholder="请输入" show-password />
      </el-form-item> -->
      <el-form-item label="新密码" prop="newPassWord">
        <el-input v-model="formData.newPassWord" autocomplete="off" placeholder="请输入" show-password />
      </el-form-item>
      <el-form-item label="确认密码" prop="checkPassWord">
        <el-input v-model="formData.checkPassWord" autocomplete="off" placeholder="请再次输入新密码" show-password />
      </el-form-item>

      <el-form-item label="验证码" prop="code">
        <el-input v-model="formData.code" type="text" autocomplete="off" placeholder="输入验证码">
          <!-- <template #prefix>
            <el-icon><Comment /></el-icon>
          </template> -->
        </el-input>

        <el-button
          :disabled="codeLoading || isCounting"
          :loading="codeLoading"
          style="color: #54dcf9"
          type="text"
          size="large"
          plain
          @click="getCode"
        >
          {{ buttonText }}</el-button
        >
      </el-form-item>
    </el-form>
    <template #footer>
      <span class="dialog-footer">
        <el-button @click="handleClose">取消</el-button>
        <el-button type="primary" :loading="loading" @click="submitForm">确定</el-button>
      </span>
    </template>
  </el-dialog>
</template>
<script setup>
import { reactive, ref, computed } from 'vue';
import { ElMessage } from 'element-plus';
import { postPhoneVerifyCode, sendUserMsg } from '@/data/api-cuser';
import storeAccount from '@/config/storeAccount.js';

const account = storeAccount();

const props = defineProps({
  visible: {
    type: Boolean,
    default: false,
  },
  theme: {
    type: String,
    default: '',
  },
  loading: {
    type: Boolean,
    default: false,
  },
});

const emit = defineEmits(['update:visible', 'submit']);

const codeLoading = ref(false);
const hasVerify = ref(false);
// const disabledSubmit = computed(() => loading.value || codeLoading.value || !checked.value);

// 倒计时相关的数据属性
const countdown = ref(60);
const isCounting = ref(false);
const buttonText = computed(() => (isCounting.value ? `${countdown.value} 秒后重新获取` : '获取验证码'));

const getCode = () => {
  formRef.value.validateField(['newPassWord'], (valid) => {
    if (valid) {
      codeLoading.value = true;
      sendUserMsg()
        .then(() => {
          ElMessage.success('验证码发送成功');
          startCountdown();
          hasVerify.value = true;
        })
        .catch(() => {
          hasVerify.value = false;
        })
        .finally(() => {
          codeLoading.value = false;
        });
    }
  });
};

const startCountdown = () => {
  isCounting.value = true;
  countdown.value = 60;
  const timer = setInterval(() => {
    if (countdown.value > 0) {
      countdown.value--;
    } else {
      clearInterval(timer);
      isCounting.value = false;
    }
  }, 1000);
};

const formRef = ref();
let formData = reactive({
  code: '',
  newPassWord: '',
  checkPassWord: '',
});

const validatePass = (rule, value, callback) => {
  if (value !== formData.newPassWord) {
    callback(new Error('新密码两次输入不一致'));
  } else {
    callback();
  }
};

const formRules = reactive({
  code: [{ required: true, message: '请输入验证码', trigger: 'blur' }],
  passWord: [{ required: true, message: '请输入原密码', trigger: 'blur' }],
  newPassWord: [
    { required: true, message: '请输入密码', trigger: 'blur' },
    {
      pattern: /^\S*(?=\S{6,})(?=\S*\d)(?=\S*[A-Z])(?=\S*[a-z])(?=\S*[!@#$%^&*? ])\S*$/,
      message: '请输入至少6位,包含大小写字母数字特殊字符的密码',
      trigger: 'blur',
    },
  ],
  checkPassWord: [
    { required: true, message: '请再次输入新密码', trigger: 'blur' },
    {
      validator: validatePass,
      trigger: 'blur',
    },
  ],
});

//表单操作
const handleClose = () => {
  formRef.value.clearValidate();
  emit('update:visible', false);
};
const submitForm = () => {
  formRef.value.validate((valid) => {
    if (valid) {
      // console.log('formData', formData);
      emit('submit', formData);
    }
  });
};
</script>
<style lang="scss">
// 暗色，平台端使用
.password-update-dialog.dark {
  position: relative;
  background: rgb(20, 30, 50);
  color: #fff;

  .bg {
    position: absolute;
    top: 0;
    left: 0;
    height: 100%;
    width: 100%;
    background: linear-gradient(352deg, rgba(133, 95, 229, 0.37) -5.26%, rgba(48, 119, 255, 0.32) 81.92%);
    box-shadow:
      rgba(77, 105, 255, 0.5) 0px 20px 50px -6px,
      rgba(69, 132, 255, 0.5) 0px 12px 40px inset;
    border-radius: 16px 16px 16px 16px !important;
  }

  .el-dialog__header,
  .el-dialog__footer {
    position: relative;
    z-index: 1;
  }

  .el-dialog__body {
    padding: 16px;
  }

  .el-dialog__title,
  .el-form-item__label {
    color: #fff;
  }

  .el-input__wrapper {
    background-color: transparent;
    color: #ffffff;
    box-shadow: none;
    border: 1px solid #6d9fff;
  }

  input,
  .el-input__prefix {
    background-color: transparent;
    color: #fff;
  }

  input:-webkit-autofill,
  input:-webkit-autofill:focus {
    transition:
      background-color 0s 600000s,
      color 0s 600000s;
    // transition-behavior: normal, normal;
    transition-duration: 0s, 0s;
    transition-timing-function: ease, ease;
    transition-delay: 600000s, 600000s;
    transition-property: background-color, color;
  }
}
</style>
